var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartyPooperIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#DCDEE1",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7337 33.068L20.667 47.3346L34.9337 42.2813M23.3337 22.0013H23.347M47.3337 28.668H47.347M38.0003 20.668H38.0137M47.3337 44.668H47.347M47.3337 20.668L44.347 21.668C43.4968 21.9512 42.7714 22.5208 42.2948 23.2796C41.8181 24.0384 41.6198 24.9392 41.7337 25.828C41.867 26.9746 40.9737 28.0013 39.8003 28.0013H39.2937C38.147 28.0013 37.1603 28.8013 36.947 29.9213L36.667 31.3346M47.3337 35.3346L46.2403 34.8946C45.0937 34.4413 43.8137 35.1613 43.6003 36.3746C43.4537 37.308 42.6403 38.0013 41.6937 38.0013H40.667M32.667 20.668L33.107 21.7613C33.5603 22.908 32.8403 24.188 31.627 24.4013C30.6937 24.5346 30.0003 25.3613 30.0003 26.308V27.3346M32.667 35.3346C35.2403 37.908 36.4403 40.8946 35.3337 42.0013C34.227 43.108 31.2403 41.908 28.667 39.3346C26.0937 36.7613 24.8937 33.7746 26.0003 32.668C27.107 31.5613 30.0937 32.7613 32.667 35.3346Z",
    stroke: "#E9353C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyPooperIcon);
export default __webpack_public_path__ + "static/media/party-pooper-icon.9b025ae158beaed96f604647776bf55e.svg";
export { ForwardRef as ReactComponent };